import {Button, Chip, IconButton, Select, Sheet, Stack, Table, Typography, Option, Modal, ModalClose, FormControl, FormLabel, Autocomplete, createFilterOptions, Tabs, TabList, Tab, TabPanel, Tooltip, ModalDialog, Input, CircularProgress } from "@mui/joy";
import { PageStandard } from "../utils/PageStandard";
import { useParams } from "react-router-dom";
import {useEffect, useState } from "react";
import {addPlayer, deletePlayer, getPlayers, getUsers, inviteUsers, togglePlayerLeader, updatePlayers } from "../utils/ViewModel";
import {FlowsTitle, PlayerModel, UserModel } from "../utils/Model";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import AddModerator from "@mui/icons-material/AddModerator";
import RemoveModerator from "@mui/icons-material/RemoveModerator";
import DeleteIcon from "@mui/icons-material/Delete";
import { isValidEmail } from "../utils/Utils";


export function GamePlayers() {
    const { id } = useParams<{ id: string }>();
    const [players, setPlayers] = useState<PlayerModel[]>([])
    const [flows, setFlows] = useState<FlowsTitle[]>([])
    const [modalAddUser, setModalAddUser] = useState(false)
    const [modalInviteUsers, setModalInviteUsers] = useState(false)
    const [users, setUsers] = useState<UserModel[]>([]);

    useEffect(() => {
        handleGetPlayers()
    }, []);

    const handleGetPlayers = () => {
        if(id) {
            getPlayers(id)
                .then((res) => {
                    if (res) {
                        setPlayers(res.players)
                        setFlows(res.flows)
                    }
                })
                .catch((err) => alert("Errore nel recupero dei partecipanti: " + err.message));
        }
    };

    function sortedPlayers(array: PlayerModel[]) {
        return array.sort((a, b) => {
            const aId = a.flow_id
            const bId = b.flow_id

            const aHas = aId !== undefined && aId !== null
            const bHas = bId !== undefined && bId !== null

            if (!aHas && !bHas) return 0
            if (!aHas) return 1
            if (!bHas) return -1

            const an = Number(aId)
            const bn = Number(bId)

            // se per qualche motivo non sono numeri, tienili “dopo” rispetto ai numerici
            const aNum = Number.isFinite(an)
            const bNum = Number.isFinite(bn)
            if (aNum && bNum) return an - bn
            if (aNum) return -1
            if (bNum) return 1
            return String(aId).localeCompare(String(bId))
        })
    }

    const handleUpdatePlayers = () => {
        if(id) {
            updatePlayers(id, players)
                .then((ok) => {
                    if (ok && refresh) refresh();
                })
                .catch((err) => alert("Errore nell'aggiornamento dei partecipanti: " + err.message));
        }
    };

    const handleFlowChange = (userId: string, flowId: string | null) => {
        setPlayers(prev =>
            prev.map(p =>
                p.user_id === userId ? { ...p, flow_id: flowId } : p
            )
        );
    };

    const refresh = async () => {
        window.location.reload()
    }

    useEffect(() => {
        getUsers().then(users => {
            setUsers(users);
        });
    }, []);

    const groupedPlayers = players
        .reduce((acc: Record<string, any[]>, player) => {
            const key = player.flow_id || "no_flow"; // assicurati che il campo sia quello giusto
            if (!acc[key]) acc[key] = [];
            acc[key].push(player);
            return acc;
        }, {});

    if (id)
    return (
        <PageStandard
            title="Gruppi e partecipanti"
            sidebarVisible={true}
            headerEnd={
                <Stack direction="row" spacing={3} alignItems="center">
                    <Typography fontFamily="monospace" level="body-sm">
                        ID: {id}
                    </Typography>
                    <Button onClick={() => setModalAddUser(true)}>
                        Aggiungi utenti
                    </Button>
                    <Button onClick={() => setModalInviteUsers(true)}>
                        Invita utenti
                    </Button>
                    <Button onClick={handleUpdatePlayers}>
                        Aggiorna
                    </Button>
                </Stack>
            }
        >
            <Tabs defaultValue={0}>
                <TabList>
                    <Tab>Tutti i partecipanti ({players.length})</Tab>
                    <Tab>Gruppi</Tab>
                </TabList>
                <TabPanel value={0}>

                    <Table aria-label="Giocatori" size="md">
                        <thead>
                        <tr>
                            <th>Cognome</th>
                            <th>Nome</th>
                            <th>Email</th>
                            <th>Notifiche</th>
                            <th>Flow</th>
                            <th>Azioni</th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                            id && sortedPlayers(players).map((player) =>
                                <PlayerRowTable player={player} experienceId={id} flows={flows} key={player.user_id} refresh={handleGetPlayers} onFlowChange={handleFlowChange} />
                            )
                        }
                        </tbody>
                    </Table>

                </TabPanel>
                <TabPanel value={1} sx={{p:0}}>
                    <Tabs defaultValue={flows[0]?.id} orientation="vertical">
                        <TabList sx={{minWidth:'200px'}}>
                            {flows.map(flow => (
                                <Tab key={flow.id} value={flow.id}>
                                    <Stack direction="column" spacing={0}>
                                        <Typography>{flow.title}</Typography>
                                        <Typography level="body-sm">{groupedPlayers[flow.id]?.length || 0} partecipanti</Typography>
                                    </Stack>
                                </Tab>
                            ))}
                            <Tab key="no_flow" value="no_flow">
                                <Stack direction="column" spacing={0}>
                                    <Typography>Senza gruppo</Typography>
                                    <Typography level="body-sm">{groupedPlayers["no_flow"]?.length || 0} partecipanti</Typography>
                                </Stack>
                            </Tab>
                        </TabList>

                        {Object.entries(groupedPlayers).map(([flowId, group]) => (
                            <TabPanel key={flowId} value={flowId} sx={{p:1}}>
                                <Table aria-label="Giocatori" size="md" sx={{ mx: 3 }}>
                                    <thead>
                                    <tr>
                                        <th>Cognome</th>
                                        <th>Nome</th>
                                        <th>Email</th>
                                        <th>Notifiche</th>
                                        <th>Flow</th>
                                        <th>Azioni</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {group.map((player) => (
                                        <PlayerRowTable
                                            player={player}
                                            experienceId={id}
                                            flows={flows}
                                            key={player.user_id}
                                            refresh={handleGetPlayers}
                                            onFlowChange={handleFlowChange}
                                        />
                                    ))}
                                    </tbody>
                                </Table>
                            </TabPanel>
                        ))}
                    </Tabs>
                </TabPanel>
            </Tabs>

            <ModalAddUser open={modalAddUser} handleClose={() => setModalAddUser(false)} experienceId={id} users={users} />
            <ModalInviteUsers open={modalInviteUsers} handleClose={() => setModalInviteUsers(false)} experienceId={id} users={users} />
        </PageStandard>
    )
}

function PlayerRowTable(props: {player: PlayerModel, experienceId: string, flows: FlowsTitle[], refresh: () => void, onFlowChange: (userId: string, flowId: string | null) => void}) {
    const player = props.player
    const experienceId = props.experienceId
    const refresh = props.refresh

    const handleDeletePlayer = () => {
        if(experienceId) {
            deletePlayer(player.user_id, experienceId)
                .then((ok) => {
                    if (ok && refresh) refresh();
                })
                .catch((err) => alert("Errore nella rimozione del partecipante: " + err.message));
        }
    };

    const handleTogglePlayerLeader = () => {
        if(experienceId) {
            togglePlayerLeader(player.user_id, experienceId)
                .then((ok) => {
                    if (ok && refresh) refresh();
                })
                .catch((err) => alert("Errore nel cambio capogruppo: " + err.message));
        }
    };



    return (
        <tr key={player.user_id}>
            <td>{player.lastname}</td>
            <td>{player.firstname}</td>
            <td>{player.email}</td>
            <td>
                <Chip
                    size="sm"
                    variant="soft"
                    color={player.notifications_enabled ? "success" : "neutral"}
                >
                    {player.notifications_enabled ? "Attive" : "Disattive"}
                </Chip>
            </td>
            <td>
                <Select
                    value={player.flow_id}
                    onChange={(_, newValue) => {
                        props.onFlowChange(player.user_id, newValue || null);
                    }}
                >
                    {
                        props.flows.map(flow =>
                            <Option key={flow.id} value={flow.id}>{flow.title}</Option>
                        )
                    }
                </Select>
            </td>
            <td>
                <Stack direction="row" spacing={1}>
                    <Tooltip title={player.is_leader ? "Rimuovi capogruppo" : "Rendi capogruppo"}
                             variant="solid"
                    >
                        <IconButton
                            variant={player.is_leader ? "solid" : "outlined"}
                            color={player.is_leader ? "danger" : "neutral"}
                            size="sm"
                            onClick={() => {
                                if(window.confirm(
                                    player.is_leader ? "Rimuovere permessi di capogruppo?" : "Attribuire permessi di capogruppo?"
                                )) {
                                    handleTogglePlayerLeader()
                                }
                            }}
                        >
                            {
                                player.is_leader ?
                                    <RemoveModerator />
                                    :
                                    <AddModerator />
                            }
                        </IconButton>
                    </Tooltip>
                    <IconButton
                        variant="outlined"
                        color="danger"
                        size="sm"
                        onClick={() => {
                            if(window.confirm("Eliminare l'utente dal gioco?")) {
                                handleDeletePlayer()
                            }
                        }}
                    >
                        <DeleteForeverIcon/>
                    </IconButton>
                </Stack>
            </td>
        </tr>
    )
}

function ModalAddUser(props: {open: boolean, handleClose: () => void, experienceId: string, users: UserModel[]}) {

    const [selectedUsers, setSelectedUsers] = useState<string[]>([]);
    const filter = createFilterOptions<UserModel>();
    const users = props.users

    const handleAddPlayers = () => {
        if (props.experienceId) {
            Promise.all(
                selectedUsers.map(user =>
                    addPlayer(props.experienceId!, user, undefined)
                )
            )
                .then(() => {
                    // Tutti i player aggiunti con successo
                    window.location.reload();
                })
                .catch((err) => {
                    alert("Errore nell'aggiunta del partecipante: " + err.message);
                });
        }
    };

    return (
        <Modal
            open={props.open}
            onClose={props.handleClose}
            sx={{display: "flex", justifyContent: "center", alignItems: "center"}}
        >
            <Sheet
                variant="outlined"
                sx={{ minWidth: 500, borderRadius: "md", p: 3, boxShadow: "lg" }}
            >
                <ModalClose variant="plain" sx={{ m: 1 }} />
                <Typography level="title-md" fontWeight="bold" mb={2}>
                    Aggiungi utenti
                </Typography>

                <FormControl size="sm" sx={{ mb: 1 }}>
                    <FormLabel>Utenti</FormLabel>
                    <Autocomplete
                        multiple
                        placeholder="Seleziona utenti"
                        options={users}
                        getOptionLabel={(option) =>
                            `${option.firstname} ${option.lastname} (${option.email})`
                        }
                        value={users.filter(u => selectedUsers.includes(u.id))}
                        onChange={(_, newValue) => {
                            setSelectedUsers(newValue.map(u => u.id));
                        }}
                        filterOptions={(options, params) => filter(options, params)}
                        renderOption={(props, option) => (
                            <li {...props} key={option.id}>
                                {option.firstname} {option.lastname} – {option.email}
                            </li>
                        )}
                        renderTags={(selected, getTagProps) =>
                            selected.map((option, index) => (
                                <Chip>{option.firstname} {option.lastname}</Chip>
                            ))
                        }
                    />
                </FormControl>

                <Stack direction="row" spacing={1} justifyContent="flex-end" sx={{mt: 2}}>
                    <Button variant="outlined" onClick={props.handleClose}>Annulla</Button>
                    <Button onClick={handleAddPlayers}>
                        Aggiungi
                    </Button>
                </Stack>
            </Sheet>
        </Modal>
    )
}

interface InviteUserModel {
    email: string;
    lastName: string;
    firstName: string;
}

function ModalInviteUsers(props: { open: boolean; handleClose: () => void; experienceId: string; users: UserModel[] }) {

    const [loading, setLoading] = useState(false);
    const initUsers = [{ email: "", firstName: "", lastName: "" }]
    const [users, setUsers] = useState<InviteUserModel[]>(initUsers/*[{email: '', lastName: '', firstName: ''}]*/);
    
    // Gestione modifica input
    const handleChange = (index: number, field: keyof InviteUserModel, value: string) => {
        const updated = [...users];
        updated[index][field] = value;
        setUsers(updated);

        // Se sto modificando l'ultima riga e non è più vuota → aggiungo una nuova riga
        if (
            index === users.length - 1 &&
            (updated[index].email || updated[index].lastName || updated[index].firstName)
        ) {
            setUsers([...updated, { email: "", lastName: "", firstName: "" }]);
        }
    };

    // Eliminazione di una riga
    const handleDelete = (index: number) => {
        const updated = [...users];
        updated.splice(index, 1);

        // Se tolgo tutto, lascio almeno una riga vuota
        if (updated.length === 0) {
            updated.push({ email: "", lastName: "", firstName: "" });
        }

        setUsers(updated);
    };

    const handleInvitePlayers = async () => {
        if (!props.experienceId) return;
        setLoading(true)
        try {
            const result = await inviteUsers(props.experienceId, users);

            const invitedCount = result.invited.length;
            const invitedEmails = result.invited.map(u => u.email).join(", ");

            alert(
                `✅ Invito completato!\n\n` +
                `Utenti invitati: ${invitedCount}\n` +
                `Email: ${invitedEmails}`
            );
            setLoading(false)
        } catch (err: any) {
            alert(`❌ Errore durante l'invito: ${err.message}`);
            setLoading(false)
        }
    };

    return (
        <Modal
            open={props.open}
            onClose={props.handleClose}
            sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
        >
            <ModalDialog size="lg" sx={{maxHeight: "90vh", minHeight: "90vh", overflowY: "auto"}}>
                <ModalClose variant="plain" sx={{ m: 1 }} />
                <Typography level="title-md" fontWeight="bold" mb={2}>
                    Invita utenti
                </Typography>

                <Table aria-label="Giocatori" size="md">
                    <thead>
                    <tr>
                        <th>Email</th>
                        <th>Cognome</th>
                        <th>Nome</th>
                        <th style={{width:"3rem"}}></th>
                    </tr>
                    </thead>
                    <tbody>
                    {users.map((user, index) => (
                        <tr key={index}>
                            <td>
                                <FormControl size="sm"
                                             error={user.email.trim()!=="" && !isValidEmail(user.email)}
                                >
                                    <Input
                                        type="email"
                                        value={user.email}
                                        onChange={(e) =>
                                            handleChange(index, "email", e.target.value)
                                        }
                                        placeholder="nome@email.com"
                                    />
                                </FormControl>
                            </td>
                            <td>
                                <FormControl size="sm">
                                    <Input
                                        type="text"
                                        value={user.lastName}
                                        onChange={(e) =>
                                            handleChange(index, "lastName", e.target.value)
                                        }
                                        placeholder="Cognome"
                                    />
                                </FormControl>
                            </td>
                            <td>
                                <FormControl size="sm">
                                    <Input
                                        type="text"
                                        value={user.firstName}
                                        onChange={(e) =>
                                            handleChange(index, "firstName", e.target.value)
                                        }
                                        placeholder="Nome"
                                    />
                                </FormControl>
                            </td>
                            <td style={{ textAlign: "center" }}>
                                {!(index === users.length - 1 &&
                                    !user.email &&
                                    !user.lastName &&
                                    !user.firstName) && (
                                    <IconButton
                                        size="sm"
                                        variant="outlined"
                                        color="danger"
                                        onClick={() => handleDelete(index)}
                                    >
                                        <DeleteIcon fontSize="small" />
                                    </IconButton>
                                )}
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </Table>
                <Button fullWidth
                        size="sm"
                        disabled={
                            loading ||
                            users.filter(u =>
                                u.email.trim() !== "" ||
                                u.firstName.trim() !== "" ||
                                u.lastName.trim() !== ""
                            ).length === 0
                        }
                        onClick={handleInvitePlayers}
                >
                    {
                        loading ?
                            <CircularProgress />
                            :
                            "Invita"
                    }
                </Button>
            </ModalDialog>
        </Modal>
    );
}